import Label from 'lib/Label';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import "./index.scss";

const ToolTipV1 = (props) => {
    const {tooltipText,label,htmlfor,trigger,type,triggerWhen,delay,selectedData,} = props
     
    return (
      <div className="tool-tip">
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="tooltip-disabled">{tooltipText}</Tooltip>}
            trigger={triggerWhen ? triggerWhen : "hover"}
            delay={{ hide: delay }}
            rootClose
            containerPadding={0}
            flip={true}
            className="overlay"
          >
            <div className={`${type} h-15px w-15px rounded-circle`}>
              {trigger}
            </div>
          </OverlayTrigger>
        </div>
      </div>
    );
}

export default ToolTipV1